export const vaultState = {
    selectedVaultUsers: [],
};
